import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors, gradient, greys } from "@clockwise/web-commons/src/styles/color.styles";
import { size, weight, lineHeight } from "@clockwise/web-commons/src/styles/type.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";

export const container: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  height: "100%",
  padding: "50px 0px 10px 0px",
};

export const content = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flexGrow: 1,
    flexShrink: 0,
    paddingTop: 5,
  } as CSSProperties,
  hero: {
    height: 110,
    width: 110,
    background: gradient,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    flexShrink: 0,
  } as CSSProperties,
  logo: {
    width: 70,
  } as CSSProperties,
  body: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: spacing.std,
    paddingRight: spacing.sm,
    paddingBottom: spacing.sm,
    paddingLeft: spacing.sm,
  } as CSSProperties,
  header: {
    textAlign: "center",
  } as CSSProperties,
  button: {
    paddingTop: spacing.sm,
  } as CSSProperties,
  agreement: {
    color: greys.slate,
    fontSize: size.sm,
    fontWeight: weight.std,
    marginTop: spacing.sm,
    textAlign: "center",
  } as CSSProperties,
  link: {
    color: greys.dark,
    borderBottomWidth: 0,
  } as CSSProperties,
};

export const signupBtn = {
  base: {
    height: 45,
    lineHeight: `45px`,
    width: "100%",
  } as CSSProperties,
  label: {
    fontSize: size.md,
    paddingLeft: spacing.std,
    paddingRight: spacing.lg,
    color: greys.white,
    textTransform: "none",
  } as CSSProperties,
};

export const linearProgress = {
  marginTop: 10,
  width: "100%",
};

export const dialog = {
  header: {
    marginTop: 20,
    marginBottom: 15,
    fontSize: size.md,
  } as CSSProperties,
  description: {
    fontSize: size.md,
    color: greys.slate,
    lineHeight: lineHeight.std,
    marginBottom: 15,
  } as CSSProperties,
  listItem: {
    fontSize: size.md,
    color: greys.slate,
    lineHeight: lineHeight.std,
    display: "flex",
    marginBottom: 10,
  } as CSSProperties,
  bullet: {
    fontSize: 18,
    color: colors.green.standard,
    marginRight: 10,
  } as CSSProperties,
  label: {
    marginTop: 3,
  } as CSSProperties,
  learnMore: {
    fontSize: size.md,
    color: greys.slate,
    lineHeight: lineHeight.std,
    marginTop: 20,
    marginBottom: 0,
  } as CSSProperties,
};
